import React from "react";
import SortableItem from "./SortableItem";

const DraggableBodyRow = ({className, ratesGroups, style, ...restProps}) => {
    if (ratesGroups?.length) {
        const index = ratesGroups.findIndex(x => x.id === restProps['data-row-key']);
        if (index !== -1) {
            return <SortableItem index={index} {...restProps}  />
        }
    }
    return false;
};

export default DraggableBodyRow;